const tableHeaders = [
  {
    label: 'user-id',
    key: 'userId',
    sortable: false,
  },
  {
    label: 'first-name',
    key: 'firstName',
    sortable: false,
  },
  {
    label: 'last-name',
    key: 'lastName',
    sortable: false,
  },
  {
    label: 'role-type-0',
    key: 'roleType',
    sortable: false,
  },
  {
    label: 'action',
    key: 'action',
    sortable: false,
  },
  {
    label: 'status',
    key: 'overAllStatus',
    sortable: false,
  },
  {
    label: 'priority',
    key: 'priority',
    sortable: false,
  },
  {
    label: 'date',
    filter: 'date',
    key: 'createdAt',
    sortable: false,
  },
  {
    label: 'view-edit-review',
    key: 'view',
    sortable: false,
  },
  {
    label: 'cancel',
    key: 'delete',
    sortable: false,
  },
];

export default () => tableHeaders;
